import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LicenseValidationFormWidgetService {
  licenseSubjects: {
    [key: string]: {
      licenseSearchSubject: BehaviorSubject<string | undefined>,
      licenseSearch$: Observable<string | undefined>
    }
  } = {
    'LicNumber': this.getLicenseQuestionSubject('LicNumber')
  };

  getLicenseQuestionSubject(licenseQuestionName: string) {
    const licenseSearchSubject = new BehaviorSubject<string | undefined>(undefined);
    const licenseSearch$ = licenseSearchSubject.asObservable();

    return {
      licenseSearchSubject,
      licenseSearch$
    };
  }

  setLicenseQuestionSubject(licenseQuestionName: string) {
    this.licenseSubjects[licenseQuestionName] = this.getLicenseQuestionSubject(licenseQuestionName);
  }
}
